import { call, takeLatest } from "redux-saga/effects";
import { Actions } from "../constants/actionTypes";
import {
  fetchInvoiceHistory,
  fetchUpcomingInvoice,
  getStripeInvoiceApi,
  getStripeUpcomingInvoiceApi,
  getTimeperiodDetailApi,
  getUserCardsSagaApi,
  getCashfreeCreateSubscriptionApi,
  getCashfreeUpdateSubscriptionApi,
  getStripeUpdateSubscriptionApi,
  getStripeCreateSubscriptionApi,
  apiStripePublishableKey,
  apiGetCashfreeDiscount,
  apiGetCashfreeAddons,
  getStripeUpdateAddonSubscriptionApi,
  apiGetFetchStatus,
  apiCreateStagingAddonStripe,
  apiCreateStagingAddonCashfree,
  apiCreateStorageAddonStripe,
  apiCreateStorageAddonCashfree,
  apiCreatePerformanceUpgradeStripe,
  apiCreatePerformanceUpgradeCashfree,
} from "../Services/payments/paymentsApi.js";

export function* getUpcomingInvoiceSaga(action) {
  yield takeLatest([Actions.GET_UPCOMING_INVOICE], getUpcomingInvoice);
}

function* getUpcomingInvoice(action) {
  const result = yield call(fetchUpcomingInvoice, action);
  return result;
}

export function* getInvoiceHistorySaga(action) {
  yield takeLatest([Actions.GET_INVOICE_HISTORY], getInvoiceHistory);
}

function* getInvoiceHistory(action) {
  const result = yield call(fetchInvoiceHistory, action);
  return result;
}

export function* getStripeInvoiceSaga() {
  yield takeLatest([Actions.GET_STRIPE_INVOICE], getStripeInvoice);
}

function* getStripeInvoice(action) {
  const result = yield call(getStripeInvoiceApi, action);
  return result;
}

export function* getStripeUpcomingInvoiceSaga() {
  yield takeLatest(
    [Actions.GET_STRIPE_UPCOMING_INVOICE],
    getStripeUpcomingInvoice
  );
}

function* getStripeUpcomingInvoice(action) {
  const result = yield call(getStripeUpcomingInvoiceApi, action);
  return result;
}

export function* getTimeperiodDetailSaga() {
  yield takeLatest([Actions.GET_TIMELINEGRAPH_DETAILS], getTimeperiodDetail);
}

function* getTimeperiodDetail(action) {
  const result = yield call(getTimeperiodDetailApi, action);
  return result;
}

export function* getUserCardsSaga() {
  yield takeLatest([Actions.GET_USER_CARDS], getUserCards);
}

function* getUserCards(action) {
  const result = yield call(getUserCardsSagaApi, action);
  return result;
}

export function* getCashfreeCreateSubscriptionSaga() {
  yield takeLatest(
    [Actions.GET_CASHFREE_CREATE_SUBSCRIPTION],
    getCashfreeCreateSubscription
  );
}

function* getCashfreeCreateSubscription(action) {
  const result = yield call(getCashfreeCreateSubscriptionApi, action);
  return result;
}

export function* getCashfreeUpdateSubscriptionSaga() {
  yield takeLatest(
    [Actions.GET_CASHFREE_UPDATE_SUBSCRIPTION],
    getCashfreeUpdateSubscription
  );
}

function* getCashfreeUpdateSubscription(action) {
  const result = yield call(getCashfreeUpdateSubscriptionApi, action);
  return result;
}

export function* getStripeCreateSubscriptionSaga() {
  yield takeLatest(
    [Actions.GET_STRIPE_CREATE_SUBSCRIPTION],
    getStripeCreateSubscription
  );
}

function* getStripeCreateSubscription(action) {
  const result = yield call(getStripeCreateSubscriptionApi, action);
  return result;
}

export function* getStripeUpdateSubscriptionSaga() {
  yield takeLatest(
    [Actions.GET_STRIPE_UPDATE_SUBSCRIPTION],
    getStripeUpdateSubscription
  );
}

function* getStripeUpdateSubscription(action) {
  const result = yield call(getStripeUpdateSubscriptionApi, action);
  return result;
}

export function* getStripeUpdateAddonSubscriptionSaga() {
  yield takeLatest(
    [Actions.GET_STRIPE_UPDATE_ADDONS],
    getStripeUpdateAddonSubscription
  );
}

function* getStripeUpdateAddonSubscription(action) {
  const result = yield call(getStripeUpdateAddonSubscriptionApi, action);
  return result;
}

export function* getStripePublishableKey() {
  yield takeLatest(
    Actions.API_GET_STRIPE_PUBLISHABLE_KEY,
    stripePublishableKeyApi
  );
}

function* stripePublishableKeyApi(action) {
  const result = yield call(apiStripePublishableKey, action);
}

export function* getCashfreeDiscount() {
  yield takeLatest(Actions.GET_CASHFREE_DISCOUNT, getCashfreeDiscountApi);
}

function* getCashfreeDiscountApi(action) {
  const result = yield call(apiGetCashfreeDiscount, action);
}

export function* getCashfreeAddons() {
  yield takeLatest(Actions.API_CREATE_ADDON_SUBSCRIPTION, getCashfreeAddonsApi);
}

function* getCashfreeAddonsApi(action) {
  const result = yield call(apiGetCashfreeAddons, action);
}

export function* apiFetchStatus() {
  yield takeLatest([Actions.API_FETCH_STATUS], fetchStatus);
}

function* fetchStatus(action) {
  const result = yield call(apiGetFetchStatus, action);
  return result;
}

export function* createStagingStripeSubscription() {
  yield takeLatest(
    [Actions.API_PAY_STAGING_STRIPE],
    createStagingStripeSubscriptionApi
  );
}

function* createStagingStripeSubscriptionApi(action) {
  const result = yield call(apiCreateStagingAddonStripe, action);
  return result;
}

export function* createStagingCashfreeSubscription() {
  yield takeLatest(
    [Actions.API_PAY_STAGING_CASHFREE],
    createStagingCashfreeSubscriptionApi
  );
}

function* createStagingCashfreeSubscriptionApi(action) {
  const result = yield call(apiCreateStagingAddonCashfree, action);
  return result;
}

// One-time storage add-on for one EBS site (siteId), same flow as staging
export function* createStorageStripeSubscription() {
  yield takeLatest(
    [Actions.API_PAY_STORAGE_STRIPE],
    createStorageStripeSubscriptionApi
  );
}

function* createStorageStripeSubscriptionApi(action) {
  const result = yield call(apiCreateStorageAddonStripe, action);
  return result;
}

export function* createStorageCashfreeSubscription() {
  yield takeLatest(
    [Actions.API_PAY_STORAGE_CASHFREE],
    createStorageCashfreeSubscriptionApi
  );
}

function* createStorageCashfreeSubscriptionApi(action) {
  const result = yield call(apiCreateStorageAddonCashfree, action);
  return result;
}

// One-time performance upgrade for one EBS site (siteId), same flow as storage
export function* createPerformanceUpgradeStripeCheckout() {
  yield takeLatest(
    [Actions.API_PAY_PERFORMANCE_UPGRADE_STRIPE],
    createPerformanceUpgradeStripeCheckoutApi
  );
}

function* createPerformanceUpgradeStripeCheckoutApi(action) {
  const result = yield call(apiCreatePerformanceUpgradeStripe, action);
  return result;
}

export function* createPerformanceUpgradeCashfreeCheckout() {
  yield takeLatest(
    [Actions.API_PAY_PERFORMANCE_UPGRADE_CASHFREE],
    createPerformanceUpgradeCashfreeCheckoutApi
  );
}

function* createPerformanceUpgradeCashfreeCheckoutApi(action) {
  const result = yield call(apiCreatePerformanceUpgradeCashfree, action);
  return result;
}
